<template>
<div>
  <el-row>
    <el-col :span="17">
  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Schedule</el-breadcrumb-item>
    <el-breadcrumb-item>Ready Dates</el-breadcrumb-item>
  </el-breadcrumb>
 </el-col>
  <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    Updating Time: {{ this.updateTime }}
    </el-col>
  </el-row>
  <!--卡片视图区域:label-position="left"-->

  <el-card>
    <el-form :model="formInline" class="demo-form-inline">
      <!--IP user-->
      <div v-if="this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='J3P'">
      <el-row>
        <el-col :span = "6">
      <el-form-item label="Supplier:" label-width="115px">
        <el-input v-model="formInline.supplier" placeholder="Supplier" clearable></el-input>
      </el-form-item>
      </el-col>
      <div v-if="this.userName.toUpperCase()==='J3P' && this.userName.toUpperCase()!=='IP'">
        <el-col :span = "6">
        <el-form-item label="Brand:" label-width="115px">
          <el-cascader v-model="formInline.brands" style="margin-left: 0px;"  placeholder="please choose"
              :options="brandOptions"
              :props="this.props"  filterable
              collapse-tags
              clearable></el-cascader>
        </el-form-item>
        </el-col>
        </div>
        <div v-else>
      <el-col :span = "6">
      <el-form-item label="Brand:" label-width="115px">
          <el-select v-model="formInline.brands" multiple collapse-tags
            style="margin-left: 0px;"  filterable
            placeholder="please choose">
          <el-option
          v-for="item in this.brandList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
          </el-form-item>
      </el-col>
      </div>
      <el-col :span = "12">
        <el-form-item label="PO Date:" label-width="200px">
          <el-date-picker
            v-model="formInline.poDate"  value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="Start Date"
            end-placeholder="End Date">
          </el-date-picker>

        </el-form-item>
      </el-col>
      </el-row>
<el-row>
  <el-col :span = "6">
  <el-form-item label="PO #:" label-width="115px">
    <el-input v-model="formInline.po" placeholder="PO #" clearable></el-input>
  </el-form-item>
  </el-col>
  <el-col :span = "6">
  <el-form-item label="Item:" label-width="115px">
            <el-input v-model="formInline.item" placeholder="Item" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span = "12">
        <el-form-item label="PI Confirmed Date:" label-width="200px">
          <el-date-picker
                v-model="formInline.piConfirmDate"  value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="Start Date"
                end-placeholder="End Date">
              </el-date-picker>
        </el-form-item>
        </el-col>
        </el-row>
        <el-row>
  <el-col :span = "6">
        <el-form-item label="Description:" label-width="115px">
          <el-input v-model="formInline.description" placeholder="Description" clearable></el-input>
        </el-form-item>
        </el-col>
  <el-col :span = "6">
    <el-form-item label="Status:" label-width="115px">
        <el-select v-model="formInline.status" multiple collapse-tags
          style="margin-left: 0px;"
          placeholder="please choose">
        <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
        <span style="float: left">{{ item.label }}</span>
        <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.value }}</span>
      </el-option>
    </el-select>

        </el-form-item>
      </el-col>
      <el-col :span = "12">
        <el-form-item label="Sch. Date 1:" label-width="200px">
          <el-date-picker
                v-model="formInline.schDate1" value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="Start Date"
                end-placeholder="End Date">
              </el-date-picker>
        </el-form-item>
</el-col>
      </el-row>
      <el-row>
        <el-col :span = "6">
          <el-form-item label="Project Desc:" label-width="115px">
                  <el-input v-model="formInline.projectDesc" placeholder="Project Desc" clearable></el-input>
                </el-form-item>
        </el-col>
<el-col :span = "6">
        <el-form-item label="Project:" label-width="115px">
                <el-input v-model="formInline.project" placeholder="Project" clearable></el-input>
              </el-form-item>

</el-col>
<el-col :span = "12" >
  <el-form-item style="margin-left: 200px;">
  <el-button type="primary" @click="onSubmit">Search</el-button>
  <el-button type="primary" @click="exportToExcel">Excel</el-button>
  </el-form-item>

      </el-col>
      </el-row>
      </div>

      <div v-else>
        <el-row>
                <el-col :span = "6">
              <el-form-item label="PO #:" label-width="115px">
                <el-input v-model="formInline.po" placeholder="PO #" clearable></el-input>
              </el-form-item>
              </el-col>
              <el-col :span = "6">
              <el-form-item label="Brand:" label-width="115px">
                  <el-select v-model="formInline.brands" multiple collapse-tags
                    style="margin-left: 0px;"  filterable
                    placeholder="please choose">
                  <el-option
                  v-for="item in brandList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span = "12">
                <el-form-item label="PO Date:" label-width="200px">

                  <el-date-picker
                    v-model="formInline.poDate"  value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="Start Date"
                    end-placeholder="End Date">
                  </el-date-picker>

                </el-form-item>
              </el-col>
              </el-row>
        <el-row>
          <el-col :span = "6">
          <el-form-item label="Item:" label-width="115px">
                    <el-input v-model="formInline.item" placeholder="Item" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span = "6">
                  <el-form-item label="Status:" label-width="115px">
                      <el-select v-model="formInline.status" multiple collapse-tags
                        style="margin-left: 0px;"
                        placeholder="please choose">
                      <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      <span style="float: left">{{ item.label }}</span>
                      <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                    </el-option>
                  </el-select>

                      </el-form-item>
                    </el-col>
                <el-col :span = "12">
                <el-form-item label="PI Confirmed Date:" label-width="200px">
                  <el-date-picker
                        v-model="formInline.piConfirmDate"  value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="Start Date"
                        end-placeholder="End Date">
                      </el-date-picker>
                </el-form-item>
                </el-col>
                </el-row>
                <el-row>
          <el-col :span = "6">
                <el-form-item label="Description:" label-width="115px">
                  <el-input v-model="formInline.description" placeholder="Description" clearable></el-input>
                </el-form-item>
                </el-col>
          <el-col :span = "6">
            <el-form-item label="Project:" label-width="115px">
                    <el-input v-model="formInline.project" placeholder="Project" clearable></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span = "12">
                <el-form-item label="Sch. Date 1:" label-width="200px">
                  <el-date-picker
                        v-model="formInline.schDate1" value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="Start Date"
                        end-placeholder="End Date">
                      </el-date-picker>
                </el-form-item>
        </el-col>
              </el-row>
              <el-row>
                <el-col :span = "6">
                  <el-form-item label="Project Desc:" label-width="115px">
                          <el-input v-model="formInline.projectDesc" placeholder="Project Desc" clearable></el-input>
                        </el-form-item>
                </el-col>
        <el-col :span = "6">
          <el-form-item  style="margin-left: 115px;">
          <el-button type="primary" @click="onSubmit">Search</el-button>
          <el-button type="primary" @click="exportToExcel">Excel</el-button>
          </el-form-item>

              </el-col>
              </el-row>
      </div>

    </el-form>

      <!-- Schedule 列表区域 -->
      <el-table :data="scheduleList" border stripe style="width: 100%">
        <el-table-column type="expand" fixed>
              <template slot-scope="props">
                <el-form inline class="demo-table-expand" border>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item label="Project Description" :show-overflow-tooltip="true">
                        {{ props.row.projectDesc }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="15"><el-form-item label="Status Description">
                      <span v-for="(item, index) in options" v-bind:key="index">
                     <span v-if="props.row.status === item.value">{{ item.description }}</span>
                     </span>
                     </el-form-item></el-col>
                  </el-row>
                  <el-row>
                   <el-col :span="6"><el-form-item label="Sch. Date 1" prop="schDate1" value-format="yyyy-MM-dd">
                    <span>{{ dateFormat1(props.row.schDate1) }}</span>
                  </el-form-item>
                   </el-col>
                   <el-col :span="15">
                   <el-form-item label="Sch. QTY1">
                                       <span>{{ numFormat1(props.row.schQty1) }}</span>
                                     </el-form-item>
                                       </el-col>
                  </el-row>

                  <el-row>
                   <el-col :span="6"><el-form-item label="Sch. Date 2">
                    <span>{{ dateFormat1(props.row.schDate2) }}</span>
                  </el-form-item>
                   </el-col>
                   <el-col :span="15">
                   <el-form-item label="Sch. QTY2">
                                       <span>{{ numFormat1(props.row.schQty2) }}</span>
                                     </el-form-item>
                                       </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="Sch. Date 3">
                                        <span>{{ dateFormat1(props.row.schDate3) }}</span>
                                      </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="Sch. QTY3">
                                                            <span>{{ numFormat1(props.row.schQty3) }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="6">
                    <el-form-item label="sch. Date 4">
                      <span>{{ dateFormat1(props.row.schDate4) }}</span>
                    </el-form-item>
                                        </el-col>
                                        <el-col :span="15">
                                        <el-form-item label="Sch. QTY4">
                                                            <span>{{ numFormat1(props.row.schQty4) }}</span>
                                                          </el-form-item>
                                                            </el-col>
                  </el-row>
                </el-form>
              </template>
            </el-table-column>

            <el-table-column type="index" fixed label="#"></el-table-column>
            <el-table-column fixed v-if="this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='J3P'"
              prop="supplier"  sortable
              label="Supplier" :show-overflow-tooltip="true"
              width="100">
            </el-table-column>
            <el-table-column fixed
              prop="brand"
              label="Brand"  sortable
              width="83">
            </el-table-column>

            <el-table-column
              prop="project" fixed
              label="Project"  sortable
              width="93">
            </el-table-column>
            <el-table-column
              prop="po"  sortable fixed
              label="PO #" :show-overflow-tooltip="true"
              width="100">
            </el-table-column>

            <el-table-column
              prop="item" fixed
              label="Item"  sortable
              width="105">
            </el-table-column>

            <el-table-column
              prop="description"
              label="Description"    :show-overflow-tooltip="true"
              width="105">
            </el-table-column>

            <el-table-column
              prop="poDate"
              label="PO Date"       sortable
              width="100" :formatter="dateFormat">
            </el-table-column>

            <el-table-column
              prop="piConfirmDate"  sortable
              label="PI Confirmed Date" :formatter="dateFormat"
              width="160">
            </el-table-column>

            <el-table-column
              prop="piConfirmateDateWarning"        :formatter="dateFormat"
              label="PI Confirmed Date Warning"
              width="190">
            </el-table-column>

            <el-table-column
              prop="orderQty"  sortable
              label="Order QTY"     :formatter="numFormat"
              width="105">
            </el-table-column>

            <el-table-column
              prop="delivered"     :formatter="numFormat"
              label="Delivered"    sortable
              width="105">
            </el-table-column>

            <el-table-column
              prop="numOfDeliveries"  sortable
              label="Number of deliveries"     :formatter="numFormat"
              width="178">
            </el-table-column>

            <el-table-column
              prop="lastDeliveryDt"  sortable  :sort-method="sortByLastDeliveryDate"
              label="Last delivery date" :formatter="dateFormat"
              width="165">
              </el-table-column>

            <el-table-column
              prop="balance"  sortable
              label="Balance"     :formatter="numFormat"
              width="92">
            </el-table-column>

            <el-table-column
              prop="status"
              label="Status"
              width="65">
            </el-table-column>

            <el-table-column
              prop="schDate1"  :sortable="true"
              label="Sch. Date 1"  :formatter="dateFormat"    :sort-method="sortBySchDate"
              width="119">
            </el-table-column>

            <el-table-column
              prop="schDate1Warning"         :formatter="dateFormat"
              label="Sch. Date 1 Warning"
              width="159">
            </el-table-column>

            <el-table-column
              prop="schQty1"
              label="Sch. QTY1"     :formatter="numFormat"
              width="105">
            </el-table-column>

            <el-table-column v-if="this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='IPIT' || this.userName.toUpperCase()==='J3P'"
              prop="deliveryPriority"
              label="Delivery Priority"         :formatter="deliveryPrioFormat"
              width="150">
            </el-table-column>

            <el-table-column
              prop="deliveryAddr"
              label="Delivery Address"
              width="130">
            </el-table-column>

            <el-table-column
              prop="changed"       sortable           :sort-method="sortByChangedDate"
              label="Changed"     :formatter="dateFormat"
              width="119">
            </el-table-column>

             <el-table-column
               prop="incotermTown"
               label="Incoterm City"     sortable
               width="136">
             </el-table-column>

          </el-table>

          <!-- 分页区域-->
           <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="formInline.page"
                :page-sizes="[10, 20, 30, 50, 100, total]"
                :page-size="formInline.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
  </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        supplier: '',
        brands: [],
        project: '',
        projectDesc: '',
        po: '',
        item: '',
        description: '',
        status: [],
        poDate: [],
        piConfirmDate: [],
        schDate1: [],
        token: '',
        page: 1,
        rows: 100
      },
      brandList: [],
      options: [{
        value: 'CUS',
        label: 'Waiting for Customer',
        description: 'Waiting for Customer'
      }, {
        value: 'DEV',
        label: 'Development',
        description: 'Development'
      }, {
        value: 'HLD',
        label: 'On Hold',
        description: 'On Hold'
      }, {
        value: 'LHK',
        label: 'Loading Hong Kong',
        description: 'Loading Hong Kong'
      }, {
        value: 'LSH',
        label: 'Loading Shanghai',
        description: 'Loading Shanghai'
      }, {
        value: 'LXI',
        label: 'Loading Xiamen',
        description: 'Loading Xiamen'
      }, {
        value: 'LYA',
        label: 'Loading Yantian',
        description: 'Loading Yantian'
      }, {
        value: 'NEW',
        label: 'New Order',
        description: 'New Order'
      }, {
        value: 'OKC',
        label: 'Confirmed to Close on arrival',
        description: 'Confirmed to Close on arrival'
      }, {
        value: 'OLO',
        label: 'On Line QC Pass',
        description: 'On Line QC Pass'
      }, {
        value: 'ONG',
        label: 'On Going Production',
        description: 'On Going Production'
      }, {
        value: 'PND',
        label: 'Pending for Approval',
        description: 'Pending for Approval'
      }, {
        value: 'PNO',
        label: 'Produce with Next Order',
        description: 'Produce with Next Order'
      }, {
        value: 'REJ',
        label: 'Reject',
        description: 'Reject'
      }, {
        value: 'RHK',
        label: 'Ready Hong Kong',
        description: 'Ready Hong Kong'
      }, {
        value: 'RSH',
        label: ' Ready Shanghai',
        description: ' Ready Shanghai'
      }, {
        value: 'RTC',
        label: 'Request to Close',
        description: 'Request to Close'
      }, {
        value: 'RXI',
        label: 'Ready Xiamen',
        description: 'Ready Xiamen'
      }, {
        value: 'RYA',
        label: 'Ready Yantian',
        description: 'Ready Yantian'
      }, {
        value: 'SFR',
        label: 'Shipment ready from France',
        description: 'Shipment ready from France'
      }, {
        value: 'SME',
        label: 'Shipment ready from Mexico',
        description: 'Shipment ready from Mexico'
      }, {
        value: 'TLB',
        label: 'Ready for Transfer to LB',
        description: 'Ready for Transfer to LB'
      }, {
        value: 'TYF',
        label: 'Ready for Transfer to Yufan',
        description: 'Ready for Transfer to Yufan'
      }, {
        value: 'WFC',
        label: 'Waiting for confirmation',
        description: 'Waiting for confirmation'
      }
      ],
      deliveryAddrArr: [{
        code: 'AD_2',
        description: 'AD_2'
      }, {
        code: 'AD_1',
        description: 'IP New York'
      }, {
        code: 'INT',
        description: 'IP Dayton'
      }, {
        code: 'TSM',
        description: 'TSM'
      }, {
        code: 'ENDEK',
        description: 'TSM'
      }, {
        code: 'FTZ',
        description: 'FTZ FG'
      }, {
        code: 'FTZ_1',
        description: 'FTZ COMPO'
      }, {
        code: 'LIFE',
        description: 'LB'
      }, {
        code: 'YFF',
        description: 'YF'
      }, {
        code: '3Star',
        description: '3Star'
      }, {
        code: 'CHI',
        description: 'ChiKwong'
      }
      ],
      brandOptions: [],
      props: { multiple: true },
      deliveryAddrFlag: 0,
      scheduleList: [],
      total: 0,
      poDateStart: '',
      poDateEnd: '',
      piConfirmDateStart: '',
      piConfirmDateEnd: '',
      schDate1Start: '',
      schDate1End: '',
      statusStr: '',
      userName: '',
      updateTime: '',
      isHandleCurrentChange: true,
      brandParam: {
        userName: '',
        userType: ''
      }
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    if (this.$route.params.selected) {
      this.formInline.project = this.$route.params.selected
      // window.sessionStorage.setItem('activePath', 'CRTask')
      // console.log('project === ' + this.$route.params.selected)
    }
    this.getSchedules()
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    this.getOptions()
    this.getBrands()
  },
  methods: {
    async getBrands () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandList = await res.brands
    },
    async getOptions () {
      const { data: res } = await this.$http.get('/customerBrand/getOptions')
      this.brandOptions = await res.rows
    },
    onSubmit () {
      this.formInline.page = 1
      this.getSchedules()
    },
    exportToExcel () {
      this.getDateRangeStr()
      /* 表示在当前页面打开新地址 https://www.myirequest.com */
      window.open('https://www.myirequest.com:8081/show/exportSchedule?supplier=' + this.formInline.supplier + '&brand=' + this.formInline.brands + '&project=' + this.formInline.project + '&projectDesc=' + this.formInline.projectDesc +
       '&po=' + this.formInline.po + '&item=' + this.formInline.item + '&description=' + this.formInline.description +
       '&status=' + this.formInline.status + '&token=' + encodeURIComponent(this.formInline.token) + // + '&poDate=' + this.formInline.poDate, '_parent')
       '&poDate=' + this.formInline.poDate + '&piConfirmDate=' + this.formInline.piConfirmDate + '&schDate1=' + this.formInline.schDate1,
      '_parent')
      this.$set(this.formInline, 'poDate', [this.poDateStart, this.poDateEnd])
      this.$set(this.formInline, 'piConfirmDate', [this.piConfirmDateStart, this.piConfirmDateEnd])
      this.$set(this.formInline, 'schDate1', [this.schDate1Start, this.schDate1End])
    },

    async getDateRangeStr () {
      this.poDateStart = ''
      this.poDateEnd = ''
      this.piConfirmDateStart = ''
      this.piConfirmDateEnd = ''
      this.schDate1Start = ''
      this.schDate1End = ''

      if (this.formInline.poDate) {
        if (this.formInline.poDate.length) {
          this.poDateStart = this.formInline.poDate[0]
          this.poDateEnd = this.formInline.poDate[1]
          this.formInline.poDate = [...this.formInline.poDate].join(',')
        }
      }

      if (this.formInline.piConfirmDate) {
        if (this.formInline.piConfirmDate.length) {
          this.piConfirmDateStart = this.formInline.piConfirmDate[0]
          this.piConfirmDateEnd = this.formInline.piConfirmDate[1]
          this.formInline.piConfirmDate = [...this.formInline.piConfirmDate].join(',')
        }
      }

      if (this.formInline.schDate1) {
        if (this.formInline.schDate1.length) {
          this.schDate1Start = this.formInline.schDate1[0]
          this.schDate1End = this.formInline.schDate1[1]
          this.formInline.schDate1 = [...this.formInline.schDate1].join(',')
        }
      }
    },
    async getSchedules () {
      var statusStr = ''
      var brandsStr = ''
      this.getDateRangeStr()

      if (this.formInline.status && this.formInline.status.length) {
        this.formInline.status = [...this.formInline.status].join(',')
        statusStr = this.formInline.status
      }

      if (this.formInline.brands && this.formInline.brands.length) {
        this.formInline.brands = [...this.formInline.brands].join(',')
        brandsStr = this.formInline.brands
      }
      const { data: res } = await this.$http.get('/show/scheduleList', { params: this.formInline })
      this.scheduleList = await res.rows
      this.total = await res.total

      if (await res.rows && this.scheduleList[0]) {
        this.updateTime = await this.scheduleList[0].createTime
      }
      await this.$set(this.formInline, 'poDate', [this.poDateStart, this.poDateEnd])
      await this.$set(this.formInline, 'piConfirmDate', [this.piConfirmDateStart, this.piConfirmDateEnd])

      await this.$set(this.formInline, 'schDate1', [this.schDate1Start, this.schDate1End])
      if (statusStr !== '') {
        await this.$set(this.formInline, 'status', statusStr.split(','))
      }
      if (brandsStr !== '') {
        await this.$set(this.formInline, 'brands', brandsStr.split(','))
      }
    },
    dateFormat1 (daterc) {
      // const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00' || daterc === '1753-01-01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00' || daterc === '1753-01-01 00:00:00') {
        return
      }

      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    numFormat1 (numrc) {
      if (numrc === null || numrc === '') {
        return
      }
      var result = ''
      var counter = 0

      numrc = (numrc || 0).toString()
      for (var i = numrc.length - 1; i >= 0; i--) {
        counter++
        result = numrc.charAt(i) + result
        if (!(counter % 3) && i !== 0) {
          result = ' ' + result
        }
      }
      return result
    },
    numFormat (row, column, cellValue, index) {
      var numrc = row[column.property]
      if (numrc === null || numrc === '') {
        return
      }
      var result = ''
      var counter = 0

      numrc = (numrc || 0).toString()
      for (var i = numrc.length - 1; i >= 0; i--) {
        counter++
        result = numrc.charAt(i) + result
        if (!(counter % 3) && i !== 0) {
          result = ' ' + result
        }
      }
      return result
    },
    deliveryPrioFormat (row, column, cellValue, index) {
      var delpri = row[column.property]
      if (delpri === 'NUT') {
        return
      }
      return delpri
    },
    deliveryAddrFormat (row, column, cellValue, index) {
      var deliveryAddr = row[column.property]
      for (var i = 0; i < this.deliveryAddrArr.length; i++) {
        if (deliveryAddr === this.deliveryAddrArr[i].code) {
          return this.deliveryAddrArr[i].description
        }
      }
      return deliveryAddr
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      if (this.total / val < this.formInline.page) {
        this.isHandleCurrentChange = false
      }
      this.getSchedules()
    },
    handleCurrentChange (val) {
      if (this.isHandleCurrentChange === true) {
        // console.log(`当前页: ${val}`)
        this.formInline.page = val
        this.getSchedules()
      }
      this.isHandleCurrentChange = true
    },
    getMonth (month) {
      var monthLetter
      switch (month) {
        case '01':
          monthLetter = 'Jan'
          break
        case '02':
          monthLetter = 'Feb'
          break
        case '03':
          monthLetter = 'Mar'
          break
        case '04':
          monthLetter = 'Apr'
          break
        case '05':
          monthLetter = 'May'
          break
        case '06':
          monthLetter = 'Jun'
          break
        case '07':
          monthLetter = 'Jul'
          break
        case '08':
          monthLetter = 'Aug'
          break
        case '09':
          monthLetter = 'Sep'
          break
        case 10:
          monthLetter = 'Oct'
          break
        case 11:
          monthLetter = 'Nov'
          break
        case 12:
          monthLetter = 'Dec'
          break
      }
      return monthLetter
    },
    sortBySchDate (obj1, obj2) {
      var val1 = Math.floor(new Date(obj1.schDate1).getTime() / 1000)
      var val2 = Math.floor(new Date(obj2.schDate1).getTime() / 1000)
      return val1 - val2
    },
    sortByChangedDate (obj1, obj2) {
      var val1 = Math.floor(new Date(obj1.changed).getTime() / 1000)
      var val2 = Math.floor(new Date(obj2.changed).getTime() / 1000)
      return val1 - val2
    },
    sortByLastDeliveryDate (obj1, obj2) {
      var val1 = Math.floor(new Date(obj1.lastDeliveryDt).getTime() / 1000)
      var val2 = Math.floor(new Date(obj2.lastDeliveryDt).getTime() / 1000)
      return val1 - val2
    }
  }
}
</script>

<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 190px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    /* width: 50%; */
  }

</style>
